import { ChangeEvent, useCallback, useMemo } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { defaultMST1020_R01Filter, useMST1020_R01Store } from "./Store_MST1020_R01";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

export const ItemSearchSection = () => {
	const { MST1020_R01Filter, setMST1020_R01Filter } = useMST1020_R01Store();
	const { itemGroupList, itemAccountList } = useCommonCodeStore();
	const { selectedItemInfo, setSelectedItemInfo } = useMST1020_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();

	const searchTextHandleFoucsId = 'searchText_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'searchText',
			category: '품목코드',
			focusId: searchTextHandleFoucsId,
			responseMapping: {
				itemCd: 'searchText',
				itemNm: 'searchTextNm',
			},
			extraFilter: () => ({
				searchText: MST1020_R01Filter.searchText || '',
				searchTextNm: MST1020_R01Filter.searchTextNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST1020_R01Filter,
		setEditData: setMST1020_R01Filter,
		defaultData: defaultMST1020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST1020_R01_search'
	});

	// 품목계정 필터링: 제품과 재공품만 표시
	const filteredItemAccountList = useMemo(() => {
		return itemAccountList.filter(item => 
			item.minorCd === '700' || item.minorCd === '400'
		);
	}, [itemAccountList]);

	// 사용여부 체크박스 핸들러
	const handleBomUseynChange = (name: string, value: string) => {
		setMST1020_R01Filter({ bomUseyn: value });
	};

	return (
		<SearchSectionForm>
			
			<SearchDropDownForm
				label="품목그룹"
				value={MST1020_R01Filter.itemGroup}
				optionList={itemGroupList}
				onChangeItem={(selectedItem) => setMST1020_R01Filter({itemGroup: selectedItem?.minorCd || ''})}
			/>
			<SearchDropDownForm
				label="품목계정"
				value={MST1020_R01Filter.itemAccount}
				optionList={filteredItemAccountList}
				onChangeItem={(selectedItem) => setMST1020_R01Filter({itemAccount: selectedItem?.minorCd || ''})}
			/>

			<SearchCodeModalForm
				label="품목코드"
				value={MST1020_R01Filter.searchText}
				valueLabel={MST1020_R01Filter.searchTextNm || ''}
				onChange={getFieldHandlers('searchText').onChange}
				onDoubleClick={getFieldHandlers('searchText').onDoubleClick}
				onKeyDown={getFieldHandlers('searchText').onEnterKeyDown}
			/>

			<div className="flex items-center pl-7 gap-2">
				<label className="h-[24px] flex items-center gap-[24px] truncate cursor-pointer">BOM등록 이력 포함 조회</label>
				<input 
					type="checkbox"
					checked={MST1020_R01Filter.bomUseyn === ''}
					onChange={(e) => handleBomUseynChange('bomUseyn', e.target.checked ? '' : 'Y')}
					className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
				/>
			</div>
		</SearchSectionForm>
	)
}; 